// extracted by mini-css-extract-plugin
module.exports = {"Signup":"Sell_Signup__3xJD3"};